import styled from 'styled-components'

const BlogIndividualStyle = styled.div`
	--smallContPadding: var(--sp63x);
	--tagSlashMargin: 0 var(--sp3x);
	--titleMargin: var(--sp5x) 0;
	--descriptionTextMargin: var(--sp6x);
	--descriptionListMargin: var(--sp3x);
	--descriptionBlockquoteMargin: var(--sp6x) 0;
	--descriptionBlockquoteTextPadding: var(--sp5x) 0 var(--sp5x) var(--sp5x);
	--shareLinkMarginTop: var(--sp7x);
	--shareTextMarginRight: var(--sp4x);
	--titleWrapMarginBottom: var(--sp10x);
	--bannerImageMargin: var(--sp12x) 0;

	margin-top: var(--sp16x);

	.banner-image {
		width: 100%;
		padding-top: 50%;
		margin: var(--bannerImageMargin);
	}

	.title-wrap {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: var(--titleWrapMarginBottom);
	}

	.share-wrap {
		display: flex;
		align-items: center;
		margin-top: var(--shareLinkMarginTop);

		.share-text {
			margin-right: var(--shareTextMarginRight);
		}
	}

	.small-cont {
		padding: 0 var(--smallContPadding);
	}

	.blog-title {
		margin: var(--titleMargin);
	}

	.tags-wrap {
		display: flex;
		flex-wrap: wrap;

		.tag-slash-wrap {
			display: flex;
			white-space: nowrap;

			.tag-slash {
				margin: var(--tagSlashMargin);
			}
		}
	}

	.description {
		p {
			font-family: Montserratarm;
			font-size: var(--p3);
			font-weight: 400;
			margin: var(--descriptionTextMargin) 0;
			line-height: var(--lineHeight);
		}

		ul,
		ol {
			list-style-type: disc;
			padding-left: var(--sp5x);
			margin: 0;

			li {
				font-family: Montserratarm;
				font-size: var(--p3);
				font-weight: 400;
				margin: var(--descriptionListMargin) 0;
				line-height: var(--lineHeight);
			}
		}

		blockquote {
			margin: var(--descriptionBlockquoteMargin);
			position: relative;

			&:before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				width: var(--sp1x);
				height: 100%;
				background-color: var(--primaryColor1);
			}

			p {
				margin: 0;
				padding: var(--descriptionBlockquoteTextPadding);
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXLMin}) {
		--smallContPadding: var(--sp48x);
		--tagSlashMargin: 0 var(--sp2x);
		--titleMargin: var(--sp5x) 0 var(--sp4x) 0;
		--descriptionTextMargin: var(--sp5x);
		--descriptionListMargin: var(--sp3x);
		--descriptionBlockquoteMargin: var(--sp5x) 0;
		--descriptionBlockquoteTextPadding: var(--sp4x) 0 var(--sp4x) var(--sp4x);
		--shareLinkMarginTop: var(--sp5x);
		--shareTextMarginRight: var(--sp3x);
		--titleWrapMarginBottom: var(--sp8x);
		--bannerImageMargin: var(--sp10x) 0;

		margin-top: var(--sp13x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeLMin}) {
		--smallContPadding: var(--sp39x);
		--tagSlashMargin: 0 var(--sp2x);
		--titleMargin: var(--sp4x) 0;
		--descriptionTextMargin: var(--sp5x);
		--descriptionListMargin: var(--sp3x);
		--descriptionBlockquoteMargin: var(--sp5x) 0;
		--descriptionBlockquoteTextPadding: var(--sp2-5x) 0 var(--sp2-5x) var(--sp5x);
		--shareLinkMarginTop: var(--sp5x);
		--shareTextMarginRight: var(--sp3x);
		--titleWrapMarginBottom: var(--sp5x);
		--bannerImageMargin: var(--sp7x) 0;

		margin-top: var(--sp11x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeMMin}) {
		--smallContPadding: var(--sp34x);
		--tagSlashMargin: 0 var(--sp2x);
		--titleMargin: var(--sp4x) 0;
		--descriptionTextMargin: var(--sp5x);
		--descriptionListMargin: var(--sp3x);
		--descriptionBlockquoteMargin: var(--sp5x) 0;
		--descriptionBlockquoteTextPadding: var(--sp2-5x) 0 var(--sp2-5x) var(--sp4x);
		--shareLinkMarginTop: var(--sp5x);
		--shareTextMarginRight: var(--sp3x);
		--titleWrapMarginBottom: var(--sp5x);
		--bannerImageMargin: var(--sp7x) 0;

		margin-top: var(--sp10x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeSMin}) {
		--smallContPadding: var(--sp30x);
		--tagSlashMargin: 0 var(--sp2x);
		--titleMargin: var(--sp4x) 0;
		--descriptionTextMargin: var(--sp5x);
		--descriptionListMargin: var(--sp3x);
		--descriptionBlockquoteMargin: var(--sp5x) 0;
		--descriptionBlockquoteTextPadding: var(--sp2-5x) 0 var(--sp2-5x) var(--sp4x);
		--shareLinkMarginTop: var(--sp4x);
		--shareTextMarginRight: var(--sp3x);
		--titleWrapMarginBottom: var(--sp5x);
		--bannerImageMargin: var(--sp6x) 0;

		margin-top: var(--sp10x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXSMin}) {
		--smallContPadding: var(--sp25x);
		--tagSlashMargin: 0 var(--sp2x);
		--titleMargin: var(--sp3x) 0;
		--descriptionTextMargin: var(--sp5x);
		--descriptionListMargin: var(--sp2x);
		--descriptionBlockquoteMargin: var(--sp5x) 0;
		--descriptionBlockquoteTextPadding: var(--sp2x) 0 var(--sp2x) var(--sp4x);
		--shareLinkMarginTop: var(--sp4x);
		--shareTextMarginRight: var(--sp3x);
		--titleWrapMarginBottom: var(--sp5x);
		--bannerImageMargin: var(--sp6x) 0;

		.title-wrap {
			flex-direction: column;
			align-items: flex-start;

			.read-next {
				margin-bottom: var(--sp4x);
			}
		}

		margin-top: var(--sp9x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.TabletSizeMin}) {
		--smallContPadding: var(--sp11x);
		--tagSlashMargin: 0 var(--sp2x);
		--titleMargin: var(--sp3x) 0;
		--descriptionTextMargin: var(--sp4x);
		--descriptionListMargin: var(--sp2x);
		--descriptionBlockquoteMargin: var(--sp4x) 0;
		--descriptionBlockquoteTextPadding: var(--sp2x) 0 var(--sp2x) var(--sp4x);
		--shareLinkMarginTop: var(--sp4x);
		--shareTextMarginRight: var(--sp3x);
		--titleWrapMarginBottom: var(--sp5x);
		--bannerImageMargin: var(--sp5x) 0;

		.title-wrap {
			flex-direction: column;
			align-items: flex-start;

			.read-next {
				margin-bottom: var(--sp4x);
			}
		}

		margin-top: var(--sp9x);
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--smallContPadding: var(--sp1x);
		--tagSlashMargin: 0 var(--sp1x);
		--titleMargin: var(--sp3x) 0;
		--descriptionTextMargin: var(--sp4x);
		--descriptionListMargin: var(--sp2x);
		--descriptionBlockquoteMargin: var(--sp4x) 0;
		--descriptionBlockquoteTextPadding: var(--sp2x) 0 var(--sp2x) var(--sp4x);
		--shareLinkMarginTop: var(--sp4x);
		--shareTextMarginRight: var(--sp3x);
		--titleWrapMarginBottom: var(--sp5x);
		--bannerImageMargin: var(--sp5x) 0;

		.title-wrap {
			flex-direction: column;
			align-items: flex-start;

			.read-next {
				margin-bottom: var(--sp3x);
			}
		}

		margin-top: var(--sp8x);
	}
`

export default BlogIndividualStyle
